import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import ReactivateUserPage from './ReactivateUserPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

function WrappedReactivateUserPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ReactivateUserPage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedReactivateUserPage as ReactivateUserPage
}
